import React from 'react';
import Navbar from './Navbar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Navbar />
      <main className="pt-16 min-h-screen">{children}</main>
      <footer className="border-t border-border">
        <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <span>Copyright {new Date().getFullYear()} Mohan Balaji</span>
          <div className="flex items-center gap-6">
            <a href="https://github.com/Mohan-Balaji" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">GitHub</a>
            <a href="https://www.linkedin.com/in/mohanbalaji2004/" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">LinkedIn</a>
            <a href="mailto:bmohanbalaji1976@gmail.com" className="hover:text-foreground transition-colors">Email</a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Layout;
